import { trustSignals } from '@/mocks/trust';

export default function TrustSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold tracking-wider uppercase rounded-full bg-primary-100 text-primary-700 mb-4">
            Why Trust Us
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-4">
            The ACBuy Spreadsheet Difference
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base leading-relaxed">
            We built this platform to be the most transparent, data-driven ACBuy spreadsheet
            comparison tool available — here's what makes it different.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {trustSignals.map((signal) => (
            <div
              key={signal.title}
              className="group p-6 md:p-7 bg-background-100 rounded-xl border border-background-200 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-xl mb-5 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${signal.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                {signal.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {signal.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}